import { EmptySpaceFiller, GroupLabel } from './SharedGroupRuleElements';
import { GroupType } from '@ardoq/api-types';
import { t, type WithI18nLocale } from '@ardoq/i18n';

type WorkspaceGroupRuleProps = WithI18nLocale;

const WorkspaceGroupRule = ({ i18nLocale }: WorkspaceGroupRuleProps) => {
  return (
    <>
      <GroupLabel data-testid={`group-by-${GroupType.WORKSPACE}-label`}>
        {t(
          i18nLocale,
          'perspectives:groupingRules.workspaceAriaLabel',
          'Workspace'
        )}
      </GroupLabel>
      <EmptySpaceFiller />
    </>
  );
};

export { WorkspaceGroupRule };
